var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vip-detail-wrap vip-background-image"},[_c('div',{staticClass:"main"},[_c('YVipHeader'),_vm._v(" "),_c('YNav'),_vm._v(" "),_c('YDetailClass')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }